// extracted by mini-css-extract-plugin
export default {"container":"FloorContainer_container__vVAFx"};